/**
 * Configuration centralisée des liens de documentation
 * Mappe les routes de l'application aux sections de documentation
 */
export const documentationMap: Record<string, string> = {
  // Dashboard
  '/dashboard': '02-premiers-pas#tableau-de-bord',
  
  // Companies (Entreprises)
  '/companies': '03-entreprises#03-2-liste',
  '/companies/create': '03-entreprises#03-3-creation',
  '/companies/:id': '03-entreprises#03-4-consultation',
  '/companies/:id/edit': '03-entreprises#03-5-modification',
  
  // Shops (Boutiques)
  '/shops': '04-boutiques#04-2-liste',
  '/shops/create': '04-boutiques#04-3-creation',
  '/shops/:id': '04-boutiques#04-4-consultation',
  '/shops/:id/edit': '04-boutiques#04-5-modification',
  
  // Clients
  '/clients': '05-gestion-clients#05-2-liste',
  '/quick-client-create': '05-gestion-clients#05-3-creation-rapide',
  '/clients/create-full': '05-gestion-clients#05-4-creation-complete',
  '/clients/:id': '05-gestion-clients#05-5-consultation',
  '/clients/:id/edit': '05-gestion-clients#05-6-modification',
  
  // Practitioners (Praticiens)
  '/practitioners': '06-gestion-praticiens#06-2-liste',
  '/practitioners/create': '06-gestion-praticiens#06-3-creation',
  '/practitioners/:id': '06-gestion-praticiens#06-4-consultation',
  '/practitioners/:id/edit': '06-gestion-praticiens#06-5-modification',
  
  // Appointments (Rendez-vous)
  '/appointments': '27-rendez-vous-et-actes-nouveau-modele',
  '/appointments/create': '27-rendez-vous-et-actes-nouveau-modele',
  '/appointments/:id': '27-rendez-vous-et-actes-nouveau-modele',
  '/appointments/:id/edit': '27-rendez-vous-et-actes-nouveau-modele',
  '/practitioner/appointments': '26-espace-praticien#26-3-rendezvous',
  '/practitioner/appointments/create': '26-espace-praticien#26-3-rendezvous',
  '/practitioner/appointments/:id': '26-espace-praticien#26-3-rendezvous',
  '/practitioner/appointments/:id/edit': '26-espace-praticien#26-3-rendezvous',
  
  // Planning
  '/planning/calendar': '08-gestion-planning#08-2-calendrier',
  '/planning/events': '08-gestion-planning#8-2-1-journal-des-evenements',
  '/planning/rules': '08-gestion-planning#08-3-regles',
  '/planning/timeoffs': '08-gestion-planning#08-4-conges',
  '/planning/audit': '08-gestion-planning#08-8-audit',
  '/planning/activity-types': '08-gestion-planning#08-6-types',
  '/planning/activity-types/create': '08-gestion-planning#08-6-types',
  '/planning/activity-types/:id/edit': '08-gestion-planning#08-6-types',
  '/planning/employee-activity-types': '08-gestion-planning#8-6-2-types-d-39-activites-employes',
  '/planning/employee-activity-types/create': '08-gestion-planning#8-6-2-types-d-39-activites-employes',
  '/planning/employee-activity-types/:id/edit': '08-gestion-planning#8-6-2-types-d-39-activites-employes',
  '/planning/activities': '08-gestion-planning#08-7-gestion',
  '/planning/activities/create': '08-gestion-planning#08-7-gestion',
  '/planning/activities/:id/edit': '08-gestion-planning#08-7-gestion',
  '/planning/acts': '27-rendez-vous-et-actes-nouveau-modele',
  '/planning/acts/create': '27-rendez-vous-et-actes-nouveau-modele',
  '/planning/acts/:id/edit': '27-rendez-vous-et-actes-nouveau-modele',
  
  // Admins
  '/admins': '09-gestion-administrateurs#09-2-liste',
  '/admins/create': '09-gestion-administrateurs#09-3-creation',
  '/admins/:id/edit': '09-gestion-administrateurs#09-5-modification',
  
  // Teams & platform users
  '/employees': '25-utilisateurs-equipes-partenaires#25-2-employes',
  '/employees/create': '25-utilisateurs-equipes-partenaires#25-2-employes',
  '/employees/:id/edit': '25-utilisateurs-equipes-partenaires#25-2-employes',
  '/vendors': '25-utilisateurs-equipes-partenaires#25-3-vendeurs',
  '/vendors/create': '25-utilisateurs-equipes-partenaires#25-3-vendeurs',
  '/vendors/:id/edit': '25-utilisateurs-equipes-partenaires#25-3-vendeurs',
  '/users': '25-utilisateurs-equipes-partenaires#25-4-utilisateurs',
  '/users/create': '25-utilisateurs-equipes-partenaires#25-4-utilisateurs',
  '/users/:id': '25-utilisateurs-equipes-partenaires#25-4-utilisateurs',
  '/users/:id/edit': '25-utilisateurs-equipes-partenaires#25-4-utilisateurs',
  
  // Settings / comms / docs
  '/settings/general': '16-parametres#16-2-paramètres-généraux',
  '/settings/preferences': '16-parametres#16-2-1-preferences',
  '/settings/profile': '16-parametres#16-3-mon',
  '/settings/password': '16-parametres#16-4-changer',
  '/settings/email-templates': '23-communications-email-sms',
  '/admin/email-logs': '23-communications-email-sms',
  '/settings/sms': '23-communications-email-sms',
  '/admin/sms-logs': '23-communications-email-sms',
  '/documents/templates': '22-documents-templates-uploads',
  '/documents/client-uploads': '22-documents-templates-uploads',
  '/documents/contracts': '22-documents-templates-uploads',
  
  // Client activity logs
  '/admin/activity-logs': '29-journal-activites-clients',
  '/clients/:id/activity': '29-journal-activites-clients#29-3-consultation-par-client',
  
  // Reception
  '/arrival': '30-accueil-client-reception',
  
  // Tasks
  '/tasks': '17-gestion-taches#17-2-liste',
  '/tasks/create': '17-gestion-taches#17-3-creation',
  '/tasks/:id/edit': '17-gestion-taches#17-4-modification',
  
  // Test cases
  '/test-cases': '28-gestion-tests',
  '/test-cases/create': '28-gestion-tests',
  '/test-cases/:id': '28-gestion-tests',
  '/test-case-instances': '28-gestion-tests',
  
  // Données de référence
  '/item-collections': '10-donnees-reference#10-1-zones-corps',
  '/body-zones': '10-donnees-reference#10-1-zones-corps',
  '/piercing-types': '10-donnees-reference#10-2-types-piercing',
  '/services': '10-donnees-reference',
  '/services/create': '10-donnees-reference',
  '/services/:id': '10-donnees-reference',
  '/services/:id/edit': '10-donnees-reference',
};

/**
 * Mappe les IDs de navigation aux chemins de documentation
 * Utilisé pour les sections principales de navigation
 */
export const navigationDocMap: Record<string, string> = {
  'dashboard': '02-premiers-pas#tableau-de-bord',
  'agenda': '08-gestion-planning',
  'calendar': '08-gestion-planning#08-2-calendrier',
  'planning-events': '08-gestion-planning#8-2-1-journal-des-evenements',
  'planning-rules': '08-gestion-planning#08-3-regles',
  'planning-timeoffs': '08-gestion-planning#08-4-conges',
  'planning-audit': '08-gestion-planning#08-8-audit',
  'planning-activity-types': '08-gestion-planning#08-6-types',
  'planning-employee-activity-types': '08-gestion-planning#8-6-2-types-d-39-activites-employes',
  'planning-activities': '08-gestion-planning#08-7-gestion',
  'planning-acts': '27-rendez-vous-et-actes-nouveau-modele',
  'clients': '05-gestion-clients',
  'clients-list': '05-gestion-clients#05-2-liste',
  'clients-create': '05-gestion-clients#05-3-creation-rapide',
  'clients-create-full': '05-gestion-clients#05-4-creation-complete',
  'team': '06-gestion-praticiens',
  'practitioners-list': '06-gestion-praticiens#06-2-liste',
  'practitioners-create': '06-gestion-praticiens#06-3-creation',
  'practitioners-applications': '06-gestion-praticiens',
  'employees-list': '25-utilisateurs-equipes-partenaires#25-2-employes',
  'employees-create': '25-utilisateurs-equipes-partenaires#25-2-employes',
  'vendors-list': '25-utilisateurs-equipes-partenaires#25-3-vendeurs',
  'vendors-create': '25-utilisateurs-equipes-partenaires#25-3-vendeurs',
  'catalogue': '10-donnees-reference',
  'companies': '03-entreprises',
  'companies-list': '03-entreprises#03-2-liste',
  'companies-create': '03-entreprises#03-3-creation',
  'shops': '04-boutiques',
  'shops-list': '04-boutiques#04-2-liste',
  'shops-create': '04-boutiques#04-3-creation',
  'practitioners': '06-gestion-praticiens',
  'appointments': '27-rendez-vous-et-actes-nouveau-modele',
  'appointments-list': '27-rendez-vous-et-actes-nouveau-modele',
  'appointments-create': '27-rendez-vous-et-actes-nouveau-modele',
  'planning': '08-gestion-planning',
  'admins': '09-gestion-administrateurs',
  'admins-list': '09-gestion-administrateurs#09-2-liste',
  'admins-create': '09-gestion-administrateurs#09-3-creation',
  'services': '10-donnees-reference',
  'services-list': '10-donnees-reference',
  'services-create': '10-donnees-reference',
  'piercing': '10-donnees-reference',
  'item-collections': '10-donnees-reference#10-1-zones-corps',
  'body-zones': '10-donnees-reference#10-1-zones-corps',
  'piercing-types': '10-donnees-reference#10-2-types-piercing',
  'users-list': '25-utilisateurs-equipes-partenaires#25-4-utilisateurs',
  'users-create': '25-utilisateurs-equipes-partenaires#25-4-utilisateurs',
  'settings': '16-parametres',
  'settings-general': '16-parametres#16-2-paramètres-généraux',
  'settings-preferences': '16-parametres#16-2-1-preferences',
  'settings-profile': '16-parametres#16-3-mon',
  'settings-password': '16-parametres#16-4-changer',
  'settings-email-templates': '23-communications-email-sms',
  'settings-sms': '23-communications-email-sms',
  'admin-email-logs': '23-communications-email-sms',
  'admin-sms-logs': '23-communications-email-sms',
  'settings-templates': '22-documents-templates-uploads',
  'settings-client-uploads': '22-documents-templates-uploads',
  'settings-contracts': '22-documents-templates-uploads',
  'admin-activity-logs': '29-journal-activites-clients',
  'arrival': '30-accueil-client-reception',
  'financial-payments': '21-paiements-et-acomptes',
  'practitioner-appointments': '26-espace-praticien#26-3-rendezvous',
  'practitioner-appointments-list': '26-espace-praticien#26-3-rendezvous',
  'practitioner-appointments-create': '26-espace-praticien#26-3-rendezvous',
};

/**
 * Fonction helper pour obtenir le lien de doc depuis la route actuelle
 * @param pathname - Le chemin actuel (ex: "/companies/123/edit")
 * @returns Le chemin de documentation ou null
 */
export function getDocPathFromRoute(pathname: string): string | null {
  // Remplacer les IDs par des placeholders
  const normalizedPath = pathname.replace(/\/[a-f0-9-]{36}/g, '/:id').replace(/\/[a-f0-9-]+/g, '/:id');
  
  // Chercher une correspondance exacte
  if (documentationMap[normalizedPath]) {
    return documentationMap[normalizedPath];
  }
  
  // Chercher une correspondance partielle (pour les routes avec paramètres)
  for (const [route, docPath] of Object.entries(documentationMap)) {
    const routePattern = route.replace(/:[^/]+/g, '[^/]+');
    const regex = new RegExp(`^${routePattern}$`);
    if (regex.test(pathname)) {
      return docPath;
    }
  }
  
  return null;
}

/**
 * Obtient le chemin de documentation pour un ID de navigation
 * @param navId - L'ID de l'item de navigation
 * @returns Le chemin de documentation ou null
 */
export function getDocPathFromNavId(navId: string): string | null {
  return navigationDocMap[navId] || null;
}

